import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// import { ReactComponent as CloseIcon } from '../../../assets/icons/close-circle.svg';
import { ReactComponent as NavigateArrow } from '../../../../assets/icons/device-management/navigate-back.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';
import { AvailableTabProperties } from '../../../../interface/location-management-side-panel.interface';
import MyButton from '../../../../shared-components/button/Button';
import SidePaneModel from '../../../../shared-components/table-side-panel/SidePaneModel';
import TabsContainer from '../../../../shared-components/tabs-container/TabsContainer';
import { permissionCheck } from '../../../../shared-functions/JWTDocodeFunction';
import AddLocation from '../../location-management/components/AddLocation';

import DeviceSearch from './DeviceSearch';

interface LocationManagementTabsProperties {
  containerTabs: AvailableTabProperties[];
  handleSwitchTab: (key: string) => void;
}

/**
 * Location Management Tabs
 * @param {LocationManagementTabsProperties} properties - The properties
 * @returns {React.JSX.Element} The rendered component
 */
function LocationManagementTabs(properties: LocationManagementTabsProperties) {
  const { t, i18n } = useTranslation('sidePanel');
  const navigate = useNavigate();
  const { containerTabs, handleSwitchTab } = properties;
  const location = useLocation();
  const [addLocationOpen, setAddLocationOpen] = useState(false);

  /**
   * Navigates back to the parent route, previous history entry, or approved charging location page.
   * @returns {void}
   */
  const goBackToParent = (): void => {
    const querySource = new URLSearchParams(location.search).get('source');
    const sourcePath = location.state?.source || querySource;
    const currentFullPath = `${location.pathname}${location.search}`;

    if (sourcePath && sourcePath !== location.pathname && sourcePath !== currentFullPath) {
      navigate(sourcePath);
      return;
    }

    const updated = location.pathname.replace(/\/(station|location)\/[^/]+\/[^/]+$/, '');
    if (updated !== location.pathname && updated !== '/ev-admin' && updated !== '/ev-admin/') {
      navigate(updated);
      return;
    }

    const hasPreviousHistory = Boolean(
      window.history.state && typeof window.history.state.idx === 'number'
        ? window.history.state.idx > 0
        : window.history.length > 1,
    );

    if (hasPreviousHistory) {
      navigate(-1);
    } else {
      navigate('/ev-admin/operations/charging-location/approved');
    }
  };
  return (
    <>
      <div
        className="container-tabs-wrap location-container-tabs-wrap station-container-tabs-wrap"
        dir={i18n.dir()}>
        <button type="button" className="navigate-arrow" onClick={goBackToParent}>
          <span>
            <NavigateArrow />
          </span>
          <div className="navigate-background" />
        </button>
        <TabsContainer containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />
        <div className="close-icon" role="presentation">
          <DeviceSearch />
        </div>
        <div>
          <MyButton
            onClickFunc={() => setAddLocationOpen(true)}
            label={t('addStation')}
            buttonType="outline"
            svgIcon={<PlusIcon />}
            disableClass="add-device-btn-custom"
            disableButton={
              !permissionCheck('partnerChargingStationAdd') &&
              !permissionCheck('cpoChargingStationAdd')
            }
          />
        </div>
      </div>
      {/* Add Location Panel */}
      <SidePaneModel
        open={addLocationOpen}
        closePanel={() => setAddLocationOpen(false)}
        content={<AddLocation onClose={() => setAddLocationOpen(false)} />}
        position="right"
        title="addStation"
      />
    </>
  );
}

export default LocationManagementTabs;
